import {v4} from "uuid";

class AccordionInitParameters {
	constructor({identifier, headerText, accordionContents, defaultCollapse, accordionCardMode, omitCard}) {
		this.Identifier = identifier;
		this.HeaderText = headerText;
		this.AccordionContents = accordionContents;
		this.DefaultCollapse = defaultCollapse;
		this.AccordionCardMode = accordionCardMode;
		this.OmitCard = omitCard;
	}

	Identifier = '';
	HeaderText = '';
	AccordionContents;
	DefaultCollapse;
	AccordionCardMode;
	OmitCard;
}

class AccordionClass {
	/**
	 * @param parameters : AccordionInitParameters
	 */
	constructor(parameters) {
		this.Parameters = parameters;
		this._instance = {};
		this._instance.AccordionInternalId = `${parameters.Identifier}-${v4()}`;
		this._instance.AccordionCollapseId = `${this._instance.AccordionInternalId}_collapse`;
	}

	load() {
		let {
			HeaderText: headerText,
			AccordionContents: accordionContents,
			DefaultCollapse: defaultCollapse,
			AccordionCardMode: accordionCardMode,
			OmitCard: omitCard
		} = this.Parameters;
		let {AccordionInternalId: accordionInternalId, AccordionCollapseId: accordionCollapseId} = this._instance;

		let accordion = $(`<div class="accordion mb-2" id="${accordionInternalId}">`);
		let accordionItem = $(`<div class="accordion-item">`);

		let accordionCollapse = $(`<div id="${accordionCollapseId}" class="accordion-collapse ${defaultCollapse}" data-bs-parent="#${accordionInternalId}">`);
		let accordionBody = $(`<div class="accordion-body">`);
		let accordionCard = $(`<div class="card card-primary card-outline mb-2">`);


		if (accordionCardMode) {
			let alternateAccordionContents = accordionBody.append(accordionContents[0].outerHTML);
			if (headerText) {
				let accordionItemHeader = $(`<h4 class="accordion-button card-header">${headerText}</h4>`);
				accordionItem.append(accordionItemHeader);
			}

			accordionCard.append(alternateAccordionContents);
			accordionCollapse.append(accordionBody);
		} else {
			if (!omitCard) {
				let accordionCardBody = $(`<div class="card-body">`).append(accordionContents[0].outerHTML);
				accordionCard.append(accordionCardBody);
				accordionBody.append(accordionCard);
				
			}
			else{
				accordionBody.append(accordionContents[0].outerHTML);				
			}

			let accordionItemHeader = $(`<h4 class="accordion-header">`);
			let accordionItemHeaderButton = $(`<button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#${accordionCollapseId}" aria-expanded="true" aria-controls="${accordionCollapseId}">`).text(headerText);

			accordionItemHeader.append(accordionItemHeaderButton);
			accordionItem.append(accordionItemHeader);
			accordionCollapse.append(accordionBody);
		}

		accordionItem.append(accordionCollapse);
		accordion.append(accordionItem);

		return {
			domObject: accordion,
			accordionInternalId,
			accordionCollapseId
		};
	}
}

export {AccordionInitParameters, AccordionClass};
